/**
 * @license
 * Copyright 2024 Google LLC
 * SPDX-License-Identifier: Apache-2.0
 */
import { MoveToNewGraphTransform } from "./move-to-new-graph.js";
import { ConfigureSidewireTransform } from "./configure-sidewire.js";
export { SidewireToNewGraphTransform };
/**
 * Given a selection of nodes and a subwire configuration information,
 * creates a new subgraph from these nodes, then configures specified
 * node to point to that subgraph.
 */
class SidewireToNewGraphTransform {
    nodeId;
    sidewirePortName;
    sourceGraphId;
    newGraphId;
    nodes;
    title;
    description;
    constructor(
    /**
     * The id of the node on which to configure the subwire.
     */
    nodeId, 
    /**
     * The port name that will be used to configure the subwire.
     */
    sidewirePortName, 
    /**
     * The graph id of the specified node ("" means main board).
     */
    sourceGraphId, 
    /**
     * The id of the graph that will be created from selected nodes.
     */
    newGraphId, 
    /**
     * The nodes that will be moved to new graph.
     */
    nodes, 
    /**
     * The title of the newly created graph.
     */
    title, 
    /**
     * The description of the newly created graph.
     */
    description = "") {
        this.nodeId = nodeId;
        this.sidewirePortName = sidewirePortName;
        this.sourceGraphId = sourceGraphId;
        this.newGraphId = newGraphId;
        this.nodes = nodes;
        this.title = title;
        this.description = description;
    }
    async apply(context) {
        const moving = await new MoveToNewGraphTransform(this.nodes, this.sourceGraphId, this.newGraphId, this.title, this.description).apply(context);
        if (!moving.success) {
            return moving;
        }
        const wiring = await new ConfigureSidewireTransform(this.nodeId, this.sidewirePortName, this.sourceGraphId, this.newGraphId).apply(context);
        if (!wiring.success) {
            return wiring;
        }
        return { success: true };
    }
}
//# sourceMappingURL=sidewire-to-new-graph.js.map